import styled from "styled-components";
export const FinanceContainer = styled.section`
  .items {
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
    display: flex;
    margin: 20px 0;
    flex-wrap: wrap;
    overflow: hidden;
    justify-content: space-between;
    .item {
      padding: 16px 8px;
      weight: 100%;
    }
  }
  .modal-link {
    color: #ca6a44;
    cursor: pointer;
  }
  .policy {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 16px 0 16px 0;
    input {
      height: 20px;
      width: 20px;
      margin-left: 10px;
    }
    label {
      display: flex;
      align-items: flex-start;
    }
  }
  .gatways {
    display: flex;
    justify-content: flex-end;
    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 2px #ccc;
      border-radius: 10px;
      margin: 5px;
      padding: 8px 16px;
      cursor: pointer;
      img {
        height: 32px;
      }
        :hover {
            border-color: #515151;
        }
    }
  }
`;
